"use client";

import { Link, Text } from "@zapier/design-system";
import styles from "./BlogCard.module.css";
import { crossDomainImageLoader } from "src/utils/images";
import { UploadcareImage } from "src/server/schemas/projects";
import { CrossDomainImage } from "./CrossDomainImage";

interface BlogCardProps {
  image?: UploadcareImage;
  title: string;
  description: string;
  href: string;
}

export const BlogCard = ({
  image,
  title,
  description,
  href,
}: BlogCardProps) => {
  return (
    <div className={styles.wrapper}>
      {image ? (
        <div className={styles.imageWrapper}>
          <CrossDomainImage
            alt={`${title} blog image`}
            src={image.url}
            loader={crossDomainImageLoader}
            fill
            style={{
              objectFit: "cover",
              objectPosition: "center center",
            }}
          />
        </div>
      ) : null}
      <div className={styles.info}>
        <div>
          <Text type="sectionHeader3">{title}</Text>
        </div>
        <p className={styles.description}>
          <Text type="paragraph3">{description}</Text>
        </p>
        <Link href={href}>Learn more</Link>
      </div>
    </div>
  );
};
